export class Page<T> {
  size: number | undefined;
  totalElements: number | undefined;
  totalPages: number | undefined;
  number: number | undefined;
  sortProperty: string | undefined;
  sortDirection: string | undefined;
  content: Array<T> | undefined;

  constructor(payload?: any) {
    if (payload) {
      this.size = payload.size;
      this.totalElements = payload.totalElements;
      this.totalPages = payload.totalPages;
      this.number = payload.number;
      this.sortProperty = payload.sortProperty;
      this.sortDirection = payload.sortDirection;
      this.content = payload.content;
    }
  }
}
